// Hashtag chip — every tag link routes to the global "Search the radar"
// page. This keeps cross-content navigation predictable for editors and
// consistent for readers across news/jobs/alerts/insights/tutorials.
import { Link } from "react-router-dom";

const tagSlug = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "unknown";

export const TagChip = ({ value, size = "sm", testid }) => {
  if (!value) return null;
  const sizeCls = size === "xs"
    ? "text-[10px] px-1.5 py-0.5"
    : "text-[11px] px-2 py-0.5";
  return (
    <Link
      to={`/search?q=${encodeURIComponent(value)}`}
      data-testid={testid || `tag-chip-${tagSlug(value)}`}
      className={`${sizeCls} bg-[#F3F4F6] text-[#4B5563] border border-[#E5E7EB] hover:border-[#111827] hover:text-[#00A878] transition-colors`}
    >
      #{value}
    </Link>
  );
};
